import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Error from '../../components/404';

const ErrorPage = () => {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>{t('errorPage.title')}</title>
                <meta name="description" content={t('errorPage.metaDescription')} />
            </Helmet>
            <Error />
        </>
    );
};

export default ErrorPage;
